export const foreignWorkerMappingTo9089AppxA = {
  name: "Foreign Worker Form Mapping",
  machine_name: "foreign_worker_9089_profile_mapping",
  targetFormDetailName: "Form ETA-9089",
  targetSectionName: "Foreign Worker </br> Information",
  targetSectionLabel: "A.A",
  fields: [
    {
      profileFieldName: "new_profile_fw_last",
      formTargetField: "appAContLastName",
    },
    {
      profileFieldName: "new_profile_fw_first",
      formTargetField: "appAContFirstName",
    },
    {
      profileFieldName: "new_profile_fw_middle",
      formTargetField: "appAContMiddleName",
    },
    {
      profileFieldName: "new_profile_fw_address",
      formTargetField: "appAContAddress1",
    },
    {
      profileFieldName: "new_profile_fw_address2",
      formTargetField: "appAContAddress2",
    },
    {
      profileFieldName: "new_profile_fw_city",
      formTargetField: "appAContCity",
    },
    {
      profileFieldName: "new_profile_fw_state",
      formTargetField: "appAContStateId",
    },
    {
      profileFieldName: "new_profile_fw_postal_code",
      formTargetField: "appAContPostalCode",
    },
    {
      profileFieldName: "new_profile_fw_country",
      formTargetField: "appAContCountryId",
    },
    {
      profileFieldName: "new_profile_fw_province",
      formTargetField: "appAContProvince",
    },
    {
      profileFieldName: "new_profile_fw_dob",
      formTargetField: "appAContDOB",
    },
    {
      profileFieldName: "new_profile_fw_class",
      formTargetField: "appAContAdmClassId",
    },
    {
      profileFieldName: "new_profile_fw_alien_reg_number",
      formTargetField: "appAContAlienReg",
    },
    {
      profileFieldName: "new_profile_fw_birth_country",
      formTargetField: "appAContBirthCountryId",
    },
    {
      profileFieldName: "new_profile_fw_citizen_country",
      formTargetField: "appAContCitizenCountryId",
    },
    {
      profileFieldName: "new_profile_fw_education",
      formTargetField: "fwEducationAppB",
    },
    {
      profileFieldName: "new_profile_fw_training_qualifications",
      formTargetField: "fwTrainingAppC",
    },
    {
      profileFieldName: "new_profile_fw_skills",
      formTargetField: "fwSkillsAppD",
    },
    {
      profileFieldName: "new_profile_fw_work_experience",
      formTargetField: "fwExpAppE",
    },
  ],
};
